<div class="relative spinner-circles-container"
    [ngClass]="spinnerContainerClass"
>
    <div *ngFor="let circle of circles"
        class="absolute rounded-full origin-center top-[50%] left-[50%] spinner-circles"
        [ngClass]="spinnerClasses"
    >
    </div>
</div>
